import React from 'react'
import logo from './logo.png'
import { TypeAnimation } from 'react-type-animation'
import Legitimacy from './legitimacy'
import Features from './features'
import Profits from './profits'
import Earnings from './earnings'
import Ending from './ending'
import referral from './referral.png'
import education from './education.png'
import staking from './staking.png'
import reward from './reward.png'
const Education = () => {
    return (
        <div>
            <div className='container-fluid' style={{ backgroundColor: "#23153c" }}>
                {/* <div className="d-flex justify-content-center"> */}
               
                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="py-md-5">
                            <div className="py-5">
                                <div>
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>LEARN & EARN</h1>

                                    {/* <h1 className='' >
                                        <TypeAnimation
                                            sequence={[
                                                // Same substring at the start will only be typed once, initially
                                                'WEALTH',
                                                1000,
                                                'LIFE',
                                                1000,
                                                'DREAMS',
                                                1000,
                                                'FORTUNES',
                                                1000,
                                                'PLANS',
                                                1000,

                                                'GOALS',
                                                1000,
                                            ]}
                                            speed={50}

                                            className="text-light display-4"
                                            style={{ fontWeight: 'bold' }}
                                            repeat={Infinity}
                                        /></h1> */}
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>WITH VCT</h1>
                                    <p className="text-light display-6">Welcome to the <b>VCT Education Hub</b>, where you’ll discover how our <b>decentralized investment system</b> works, understand our <b>income opportunities</b>, and explore the <b>future of VCT through our roadmap.</b>

                                    </p>
                                    {/* <p className="text-light h4">VCT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={education} class="brand-image p-md-none" alt="..." />
                    </div>
                </div>
                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="">
                            <div className="py-5">
                                <div>
                                    <h1 style={{ fontWeight: 500 }} className="display-4 my-3 text-light">What Are Instant Referral Rewards?                </h1>
                                    <p className="text-light h5">The Instant Referral Rewards system is simple and transparent:</p>
                                    <ol>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L1-L3</b> By referring 1 valid user, the referrer gets 10% of <b>$10</b> Bonus reward if his account is initially funded by <b>$100</b>
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L4</b> By referring 1 valid user, the referrer gets 10% of <b>$50</b> Bonus reward if his account is initially funded by <b>$500</b>
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L5</b> By referring 1 valid user, the referrer gets 10% of <b>$100</b> Bonus reward if his account is initially funded by <b>$1000</b>
                                        </li>
                                    </ol>
                                    {/* <p className="text-light h4">VCT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={referral} class=" p-md-none p-5 img-fluid" alt="..." />
                    </div>
                </div>
                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="">
                            <div className="py-5">
                                <div>
                                    <h1 style={{ fontWeight: 500 }} className="display-4 my-3 text-light">What Are Monthly Staking Rewards?                </h1>
                                    <p className="text-light h5">VCT's staking system is straightforward and transparent. Here’s how it works:</p>
                                    <ol>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L1-L3</b> user registered with L1, L2 & L3 account will be rewarded staking bonus of <b>20%</b> monthly of his total staked amount that is <b>$100</b>
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L4</b> user registered with L4 account will be rewarded staking bonus of <b>20%</b> monthly of his total staked amount that is <b>$500</b> 
                                        </li>
                                        
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L5</b> user registered with l5 account will be rewarded staking bonus of <b>20%</b> monthly of his total staked amount that is <b>$1000</b> 
                                        </li>
                                        
                                    </ol>
                                    {/* <p className="text-light h4">VCT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={staking} class=" p-md-none p-5 img-fluid" alt="..." />
                    </div>
                </div>
                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="">
                            <div className="py-5">
                                <div>
                                    <h1 style={{ fontWeight: 500 }} className="display-4 my-3 text-light">What Are Level Rewards?                </h1>
                                    <p className="text-light h5">VCT's staking system is straightforward and transparent. Here’s how it works:</p>
                                    <ol>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L2 Promotion</b> User upgraded to L2 from L1 will be rewarded a <b>brand new mobile phone</b> from VCT
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L3 Promotion</b> User upgraded to L3 from L2 will be rewarded a <b>latest motorbike</b> from VCT
                                        </li>
                                        
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L4 Promotion</b> User upgraded to L4 from L3 will be rewarded a <b>travelling tickets</b> from VCT
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L5 Promotion</b> User upgraded to L5 from L4 will be rewarded a <b>MG Car</b> from VCT
                                        </li>
                                        <li className="text-light h5" style={{ fontWeight: 400 }}><b>L6 Promotion</b> User upgraded to L6 from L5 will be rewarded a <b>Fortuner</b> from VCT
                                        </li>
                                        
                                    </ol>
                                    {/* <p className="text-light h4">VCT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={reward} class=" p-md-none p-5 img-fluid" alt="..." />
                    </div>
                </div>

            </div>

            <div className="container-fluid px-md-5 py-md-5">
                <Ending />

            </div>
        </div>
    )
}

export default Education